import { LucideProps } from "lucide-react";
import { useTranslation } from "react-i18next";

type AddBlockIconProps = {
  title: string;
  description: string;
  icon: React.FC<LucideProps>;
  hasDynamicContent?: boolean;
};

export function AddBlockIcon({
  title,
  description,
  icon: Icon,
  hasDynamicContent,
}: AddBlockIconProps) {
  const { t } = useTranslation("trackoffice");

  return (
    <div className="flex bg-muted/60 gap-2 items-center p-2 w-full rounded-lg">
      <div className="border bg-card size-8 mt-2 rounded-sm flex items-center justify-center text-muted-foreground">
        <Icon className="size-4" />
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-1.5">
          <span className="text-xs font-medium">{title}</span>
          {hasDynamicContent && (
            <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary/10 text-primary font-medium">
              {t("templatesEditor.blocksList.dynamicTag", "dynamic")}
            </span>
          )}
        </div>
        <p className="text-muted-foreground text-xs">{description}</p>
      </div>
    </div>
  );
}
